<template>
    <div v-if="isVisible" class="success-toast">
        <h3 v-if="title">
            {{title}}
        </h3>
        <h6 v-if="subtitle">
            {{subtitle}}
        </h6>
        <p v-if="description">
            {{description}}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        propTitle: {
            required: false,
            default: "Adicionado"
        },
        propSubtitle: {
            required: false,
        },
        propDescription: {
            required: false,
            default: "Artigo adicionado ao carrinho com sucesso"
        },
    },
    data () {
        return {
            isVisible: false,
            title: "Adicionado",
            subtitle: false,
            description: "Artigo adicionado ao carrinho com sucesso"
        }
    },
    created() {
        window.addEventListener('show-toast', (event) => {
            //update title sub and desc with event info here
            console.log(event)
            this.description = event.detail.message;

            this.openToast();
        });
    },
    mounted() {
        if (this.propTitle) {
            this.title = this.propTitle
        }
        if (this.propSubtitle) {
            this.subtitle = this.propSubtitle
        }
        if (this.propDescription) {
            this.description = this.propDescription
        }
    },
    methods: {
        openToast() {
            this.isVisible = true
            setTimeout(() => this.isVisible = false, 3000);
        }
    },
}
</script>

<style scoped>

.success-toast{
    background: #4bb543;
    color: white;
    position: fixed;
    top: 0;
    z-index: 100;
    right: 0;
    top: 10%;
    padding: 1rem 2rem;
    border-radius: 5px 0px 0px 5px;
    animation: 0.5s linear 0s 0.5 slideInFromLeft;
}

@keyframes slideInFromLeft {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}
</style>